<template>
  <BaseDialog :isOpen="isOpen">
    <template v-slot:title>
      <span>Are you sure you want to submit the booking for approval?</span>
    </template>
    <template v-slot:body>
      <div class="approval-booking-description">
        You will not be able edit this booking once you have done this.
      </div>
    </template>
    <template v-slot:actions>
      <div class="approval-booking-actions">
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          Submit
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import {
  BOOKINGS_NAMESPACE,
  SUBMIT_BOOKING_FOR_APPROVAL
} from "@/store/modules/bookings/actions";

const { mapActions } = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  name: "BookingApprovalDialog",
  components: { PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  props: {
    isOpen: Boolean
  },
  inject: ["currentBookingId"],
  methods: {
    ...mapActions({
      submitForApproval: SUBMIT_BOOKING_FOR_APPROVAL
    }),
    async handleSubmit() {
      this.isLoading = true;
      try {
        await this.submitForApproval(this.currentBookingId);
        this.$emit("close");
      } finally {
        this.isLoading = false;
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.approval-booking-description {
  min-height: 100px;
}
</style>
